export const getOrderSummaryItemName = ({ name, quantity = 1, }) => (quantity > 1 ? `${name} x ${quantity}` : name);
//# sourceMappingURL=getOrderSummaryItemName.js.map